var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AnimaArticle',[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('Rules.text'))}})])}
var staticRenderFns = []

export { render, staticRenderFns }